

import { useEffect, useRef, useState } from "react";


// import logo from "../images/HD-Logo.png"
import axios from "axios";
// import "./css/chatbot.css";
// import { Box, Button, Flex, Image, Spinner, Text, Textarea } from "@chakra-ui/react";
// import {Dictaphone} from "./Dictaphone";

// const init = {
//   role: "system",
//   content: " I am Fitness Expert from WellFit "
// }


export const Chatbot = () => {
  const inputRef = useRef(null);
  const [input, setinput] = useState("")
  // const [bot, setbot] = useState([init])
  const [ loading, setLoading] = useState(false)
  const [chatHistory,setchatHistory] = useState([{role:"system",content:"Hi 👋, I am AI Assistant of WellFit."}])
  console.log(input)
 
  const handlesubmit = async (e) => {
    e.preventDefault();
    const message =  [{role:'system', content: `Take a role of AI Assistant of  fitness website WEllFit and respond to only queries which are related to WellFit or the queries which are general fitness queries like what is the nutrients value of 2 eggs?.You are not at all supposed to respond to any queries which are not related to our website WellFit or general fitness related queries. If you encounter such query then respond saying I am an AI Assistant of Fitness Website WellFit so I can't answer questions like these. Here's the query: \n${input}`},{ role: "user", content: input }];
    const newdata = message

    // setbot(newdata);
    try {
      setLoading(true)
      const response = await axios.post(
        "https://api.openai.com/v1/chat/completions",
        {
          model: "gpt-3.5-turbo",
          messages: newdata,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.REACT_APP_OPENAI_SECRET}`,
          },
        }
      );

      const chatbotMessage = response.data.choices[0].message.content;
      console.log(chatbotMessage);
      const updatedChatHistory = [
        ...chatHistory,
        { role: "user", content: input },
        { role: "assistant", content: chatbotMessage },
      ];
      console.log(updatedChatHistory);
      setchatHistory(updatedChatHistory);
      setLoading(false)
      setinput("");
      inputRef.current.focus();
    } catch (error) {
      console.error(error);
    }

  }





  return (
    <div className="mb-10">
      <div className="chat">
        <div className="flex items-center avatar">
        </div>
      </div>
      <div className="messages mt-2">
        <div className="messages-content">
          {chatHistory.map((message, index) => (
            <div key={index} className={`message ${message.role === 'user' ? 'message-user self-end bg-teal-400 text-white' : 'message-assistant bg-[#171A26] mt-2 text-white'}`}>
              <div className="message-content p-3 rounded-md shadow-md">
                <p className="text-base">
                  {message.content}
                </p>
              </div>
              {message.role === 'user' && (
                <div className="absolute right-0 mr-2 mt-1">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M12.293 3.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 9H2a1 1 0 110-2h12.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
      <form className="mt-24" onSubmit={handlesubmit}>
        <div className="flex items-center message-box w-3/4 m-auto">
          <textarea style={{width:"90%"}} className="mt-40 flex-1 h-12 py-2 px-3 text-black border-2 border-gray-300 rounded-lg mr-2 focus:outline-none focus:border-blue-400" placeholder="Ask a question..." value={input} onChange={(e) => setinput(e.target.value)} ref={inputRef}></textarea>
          <div className="w-20 mt-40">
            <button type="submit" className="w-full py-2 px-4 bg-black text-white rounded-lg text-center focus:outline-none hover:bg-gray-800">
              {loading?"Sending..":"Send"}
            </button>
          </div>
        </div>
      </form>
    </div>



  )
}
